import React from 'react';
import TextContainer from '../TextContainer';
import { withStyles, Typography, Link } from '@material-ui/core';
import styles from './Disclaimer.css';

function Disclaimer(props) {

    const {classes} = props;

    return (
        <div className={classes.disclaimer}>
            <TextContainer>
                <Typography variant="h5">Disclaimer</Typography>
                <br></br>
                <Typography variant="body1" component={'span'}>

                By submitting images you acknowledge that:
                <ul>
                    <li>You have permissions to perform analysis on them.</li>
                    <li>You allow the owner of this site to use the submitted images for bioimage informatics research purposes.</li>
                    <li>You allow the owner of this site for anonymized publication of the submitted images.</li>
                </ul>
                We store IP address.<br/>
                You can review our <Link href={'/cookies'}>Cookies Policy</Link> and <Link href={'/privacy'}>Privacy Policy</Link>.
                </Typography>
            </TextContainer>
        </div>
    );
}

export default withStyles(styles, {withTheme: true})(Disclaimer);
